import { texts } from "@sveabank/cc-common";
import luhn from "luhn";
import type { BankGiroFormValues } from "../types/bankgiro";

// 1234-1234 or 123-1234
const correctBGFormatRegex = /^[0-9]{3,4}(-)[0-9]{4}$/;

const isValidBgNumberFormat = (n: string) =>
	correctBGFormatRegex.test(n) && luhn.validate(n.replace("-", ""));

export const validateBgNumber = (n: string) =>
	isValidBgNumberFormat(n) ? undefined : texts.validation.invalidBg;

export const isValidBgForm = (
	formValues: BankGiroFormValues | undefined,
	hasCheckCreditProduct?: boolean,
): formValues is Required<BankGiroFormValues> => {
	if (!formValues) return false;
	if (formValues.answer === "transferExisting" && !!formValues.existingNumber) {
		const isValidFormat = isValidBgNumberFormat(formValues.existingNumber);
		return isValidFormat;
	}
	if (formValues.answer === "notInterested") {
		return !hasCheckCreditProduct;
	}
	return formValues.answer === "createNew";
};
